<template>
  <v-data-table
    :value="selected"
    :headers="columns"
    :items="groups"
    item-key="groupId"
    show-select
    :server-items-length="total"
    :options.sync="tableOptions"
    :items-per-page="itemsPerPage"
    :page.sync="currentPage"
    class="elevation-0 group-table"
    :class="{
      'cursor-pointer': clickableRows,
    }"
    :loading="loading"
    loading-text="Loading... Please wait"
    no-data-text="No groups found"
    no-results-text="No groups found in search"
    @click:row="handleRowClick"
    @input="$emit('update:selected', $event)"
    :footer-props="footerProps"
    must-sort
    :sort-desc="true"
    sort-by="groupId"
  >
    <template v-slot:loading>
      <!-- {{ item }} -->
      <v-progress-circular
        indeterminate
        color="primary"
        class="my-8"
        :size="50"
        :width="4"
      ></v-progress-circular>
    </template>
    <template v-slot:[`item.data-table-select`]="{ item }">
      <v-simple-checkbox
        color="darkGrey"
        class="py-0 my-0"
        hide-details
        :ripple="false"
        @click.stop="handleCheckboxClick(item)"
        :value="!!selected.find((x) => item && x.groupId == item.groupId)"
      />
    </template>
    <template v-slot:[`item.groupDisplayName`]="{ item }">
      <span class="word-break">{{ item.groupDisplayName || "" }}</span>
    </template>
    <template v-slot:[`item.groupType`]="{ item }">
      {{ groupTypeLabel(item.groupType) }}
    </template>
    <template v-slot:[`item.numInGroup`]="{ item }">
      <div class="d-flex align-center">
        <v-icon class="mr-2">mdi-account-multiple</v-icon>
        <span class="mr-5">{{
          !item ? "-" : item.numUsers !== undefined ? item.numUsers : "-"
        }}</span>
      </div>
    </template>
    <template v-slot:[`item.qr`]="{ item }">
      <v-btn
        icon
        small
        color="brandCyan"
        v-if="showQrCodeForItem(item)"
        @click.stop="$emit('qr-click', item.groupId)"
        ><v-icon>mdi-qrcode</v-icon></v-btn
      >
    </template>
  </v-data-table>
</template>

<script>
import { groupTypeLabel } from "@/utils/groupTypeLabel";

export default {
  name: "GroupsDataTable",
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    page: {
      type: Number,
      default: 1,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    footerProps: {
      type: Object,
      default: () => ({}),
    },
    clickableRows: {
      type: Boolean,
      default: false,
    },
    clientId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    tableOptions: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit("update:options", value);
      },
    },
    currentPage: {
      get() {
        return this.page;
      },
      set(value) {
        this.$emit("update:page", value);
      },
    },
  },
  methods: {
    groupTypeLabel,
    handleRowClick(item) {
      if (!this.clickableRows) return;
      this.$emit("row-click", item);
    },
    handleCheckboxClick(item) {
      this.$emit("checkbox-click", item);
    },
    showQrCodeForItem(item) {
      // QR code is shown for QR group types and matching clientId
      return item.groupType === "QR" && item.clientId === this.clientId;
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
